import { Injectable, computed, signal } from '@angular/core';
import { AppNotification, NotificationType } from '../models/notification.model';

let _seq = 1;
function newId(): string {
  return `notif-${Date.now()}-${_seq++}`;
}

export interface PushNotificationPayload {
  type: NotificationType;
  title: string;
  body: string;
  recipientEmployeeId: string | number;
  recipientName: string;
  actionUrl: string | null;
}

@Injectable({ providedIn: 'root' })
export class NotificationStateService {
  private _items = signal<AppNotification[]>([]);

  readonly notifications = this._items.asReadonly();

  readonly unreadCount = computed(() => this._items().filter(n => !n.read).length);

  readonly hasUnread = computed(() => this.unreadCount() > 0);

  push(payload: PushNotificationPayload): void {
    const notification: AppNotification = {
      id: newId(),
      ...payload,
      createdAt: new Date(),
      read: false
    };
    this._items.update(items => [notification, ...items]);
  }

  markRead(id: string): void {
    this._items.update(items =>
      items.map(n => n.id === id ? { ...n, read: true } : n)
    );
  }

  markAllRead(): void {
    this._items.update(items => items.map(n => ({ ...n, read: true })));
  }
}
